import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer_v1 extends Component {


	constructor(props) {
		super(props);
		this.state = {
			Newscategories: [],
		};
	}

	fetchCategories() {
		const apiUrlNewsCat = 'https://khapa.tagit.pk/api/blog.php?category=news_categories';

		fetch(apiUrlNewsCat)
			.then(response => response.json())
			.then(data => {
				// Assuming the data is an array of categories
				if (Array.isArray(data)) {
					this.setState({ Newscategories: data });
				} else {
					console.error('Unexpected data format:', data);
				}
			})
			.catch(error => console.error('Error fetching categories:', error));
	}

	componentDidMount() {
		const $ = window.$;

		let publicUrl = process.env.PUBLIC_URL + '/'
		const minscript = document.createElement("script");
		minscript.async = true;
		minscript.src = publicUrl + "assets/js/main.js";

		document.body.appendChild(minscript);

		var bodyOvrelay = $('#body-overlay');
		var searchPopup = $('#td-search-popup');

		$(document).on('click', '#body-overlay', function (e) {
			e.preventDefault();
			bodyOvrelay.removeClass('active');
			searchPopup.removeClass('active');
		});
		$(document).on('click', '.search', function (e) {
			e.preventDefault();
			searchPopup.addClass('active');
			bodyOvrelay.addClass('active');
		});
		// Fetch categories when component mounts
		this.fetchCategories();
	}

	render() {
		const { Newscategories } = this.state;

		return (
			<div className="footer-area bg-black pd-top-95">
				<div className="container">
					<div className="row">
						<div className="col-lg-4 col-sm-6">
							<div className="widget">
								<h5 className="widget-title">ABOUT US</h5>
								<div className="widget_about">
									<p>Stay informed with the latest news, insights, and expert analysis on topics shaping the Middle East and the Muslim world. Your trusted source for authentic and timely updates!</p>
									<ul className="social-area social-area-2 mt-4">
										<li><a className="facebook-icon" href="#"><i className="fa fa-facebook" /></a></li>
										<li><a className="instagram-icon" href="#"><i className="fa fa-instagram" /></a></li>
										<li><a className="twitter-icon" href="#"><i className="fa fa-twitter" /></a></li>
										<li><a className="youtube-icon" href="#"><i className="fa fa-youtube" /></a></li>
										<li><a className="linkedin-icon" href="#"><i className="fa fa-linkedin" /></a></li>

									</ul>
								</div>
							</div>
						</div>
						{/* <div className="col-lg-4 col-sm-6">
							<div className="widget widget_tag_cloud">
								<h5 className="widget-title">QUICK LINKS</h5>
								<div className="tagcloud go-top">
								{Newscategories.map(category => (
										<Link key={category.id} to={`/cat-news/${category.id}`}>{category.category}</Link>
									))}
								</div>
							</div>
						</div> */}
						<div className="col-lg-4 col-sm-6">
							<div className="widget">
								<h5 className="widget-title">CONTACTS</h5>
								<ul className="contact_info_list">
									<li><i className="fa fa-phone" /> +92 (123) 456-7890</li> {/* Phone Number */}
									<li><i className="fa fa-envelope-o" /> contact@tagit.pk</li>
									<li><i className="fa fa-map-marker" /> 1234 Street Name, City, Country</li> {/* Address */}
									<li><i className="fa fa-map-marker" /> Office 567, Another City, Country</li> {/* Additional Address */}
								</ul>
							</div>
						</div>
						<div className="col-lg-4 col-sm-6 go-top">
							<div className="widget widget_recent_post">
								<h5 className="widget-title">POPULAR LINKS</h5>
								<ul className="contact_info_list">
									<li><Link to="/">Home</Link></li>
									<li><Link to="#">Privacy Policy</Link></li>
									<li><Link to="#">Terms And Condition</Link></li>
								</ul>
							</div>
						</div>
					</div>
					<div className="footer-bottom text-center">
						<ul className="widget_nav_menu go-top">
							{Newscategories.map(category => (
								<li key={category.id}>
									<Link to={`/cat-news/${category.id}`}>{category.category}</Link>
								</li>
							))}
						</ul>
						<p>Copyright ©2025 TagIt made by <a href='https://www.linkedin.com/in/muhammad-bilal-25a568b4' target='_blank'>Bilal</a></p>
					</div>
				</div>
			</div>

		)
	}
}


export default Footer_v1